<template>
  <div>
    <v-flex pl-0>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
            v-mask="'####-##-##'"
            v-model="dateFormatted"
            :label="label"
            v-on="on"
            append-icon="event">
          </v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
 
export default {
  name: 'date-picker',
  directives: {mask},
  data: (vm) => ({
    date: null,
    dateFormatted: null,
    menu: false,
    dateValid: true
  }),
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
      this.$emit('input', this.date)
    },
    value: {
      immediate: true,
      handler () {
        this.date = this.value
      }
    },
    dateFormatted(val) {
      if (val === '') return this.date = ''
      if (!val) return
      let res = val.split('-')
      if (res.length == 3 && res[2].length == 4 && this.formatDate(this.date) != this.dateFormatted) {
        let tzoffset = (new Date()).getTimezoneOffset() * 60000
        let d = new Date(`${res[2]}-${res[1]}-${res[0]}`)
        let dd = d.getTime()
        let localISOTime = (new Date(dd - tzoffset)).toISOString().substr(0, 10)
        this.date = localISOTime
      }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
  }
}
</script>
